import { ReactNode } from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import { colors } from '../../styles/GlobalStyles';
import { Icon, IconInfo, InfoSmallIcon } from '../../styles/Icons';
import { Flexed } from '../../styles/GlobalComponents';

const WrapperStyled = styled.div<{ margin?: string; color?: string }>`
  margin: ${({ margin }) => (margin ? margin : '12px 0')};
  display: inline;
  svg {
    path {
      stroke: ${({ color }) => color};
    }
  }
`;

export const TextWithTooltip = ({
  children,
  tooltip,
  margin,
  width = '200px',
  link,
  center,
  color,
  column
}: {
  children?: ReactNode;
  tooltip: ReactNode;
  margin?: string;
  width?: string;
  link?: boolean;
  center?: boolean;
  color?: string;
  column?: string;
}) => {
  const id = Math.random().toString();

  return (
    <WrapperStyled margin={margin} data-tip data-for={id} color={color}>
      {children}

      {tooltip && (
        // <Icon >
        <span style={{ display: 'inline', marginLeft: 4 }}>
          <InfoSmallIcon />
        </span>
        // </Icon>
      )}

      <ReactTooltip
        id={id}
        place='top'
        effect='solid'
        backgroundColor='#fff'
        textColor={link ? colors.primary900 : colors.neutral900}>
        {center ? (
          <Flexed justifyCenter width={width}>
            {tooltip}
          </Flexed>
        ) : (
          <Flexed column={column} width={width}>
            {tooltip}
          </Flexed>
        )}
      </ReactTooltip>
    </WrapperStyled>
  );
};
